


let _ = require('../_.js');
let $ = jQuery;

_.AuctionUI_Agents = class AuctionUI_Agents {

    /**
     * Canonical website profile URL /agent/{id}/{slug}; slug rule matches WordPress Lp_Agents::slug() and ACE User::profile_slug().
     */
    static profile_url(agent) {
        let slug = ((agent.first_name || '') + ' ' + (agent.last_name || '')).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        return '/agent/' + agent.id + '/' + (slug || 'profile');
    }

    static async update_agents() {

        let property = _.ac_state.property;

        let agents = await property.agents.fetch();

        // console.log(agents);

        _.landproz_layout_set_options({ 'multiple_agents': agents.length > 1 });

        // agents.sort((a, b) => a.agent_order - b.agent_order);

        let $agents_container = $("#landproz-auctioncast-agents");

        let agent_ids = [];
        let agent_promises = [];
        let count_found_agents = 0;

        for (let agent of agents) {
            // Run these in parallel
            let headshot = await agent.headshot.fetch();

            if (!headshot) {
                // Todo: set default image
                continue;
            }

            count_found_agents++;

            let $agent = $agents_container.component(agent.id);

            if (!$agent.data('agent-init')) {
                $agent.data('agent-init', true);
                $agent.on('click', function () {
                    window.location.href = _.AuctionUI_Agents.profile_url(agent);
                });
            }

            agent_ids.push(agent.id);

            $agent.find(".agent-name").text(agent.first_name + " " + agent.last_name);
            $agent.find(".agent-subtitle").text(agent.title);
            $agent.find(".agent-info-email-value").text(agent.email.toUpperCase());
            $agent.find(".agent-info-phone-value").text(_.formatPhoneNumber(agent.phone_number));

            // $agent.find(".agent-image").css("background-image", "url('" + headshot.direct_url + "')");
            $agent.find(".agent-image").divimg(headshot);
        }

        await Promise.all(agent_promises);

        $agents_container.remove_unlisted_components(agent_ids);

        $agents_container.show();

        if (count_found_agents == 0) {
            $(".ac-box-wrapper-b").hide();
        } else {
            $(".ac-box-wrapper-b").show();
        }

    }

    static init() {
        console.log("Update agents");
        _.AuctionUI_Agents.update_agents();
    }

}